/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { openPositionSummarySchema } from './openPositionSummarySchema';
import { teamMemberResponseSchema } from './teamMemberResponseSchema';

export const teamLookupResponseSchema = z.object({
  description: z.string().nullish(),
  id: z.int(),
  get members() {
    return z.array(teamMemberResponseSchema).nullish();
  },
  name: z.string(),
  get openPositions() {
    return z.array(openPositionSummarySchema).nullish();
  },
  remainingCapacitySeconds: z.int().nullish(),
  totalCapacitySeconds: z.int().nullish(),
  totalFte: z.number().nullish(),
});
